import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function FadeUp({ children, delay = 0, className = "", y = 30 }) {
    return (
        <motion.div
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.85, delay, ease: EASE }}
            className={className}
        >
            {children}
        </motion.div>
    );
}

export function MaskLine({ children, delay = 0, className = "" }) {
    return (
        <span className={`block overflow-hidden ${className}`}>
            <motion.span
                className="block"
                initial={{ y: "112%" }}
                animate={{ y: "0%" }}
                transition={{ duration: 1, delay, ease: EASE }}
            >
                {children}
            </motion.span>
        </span>
    );
}

export function SectionHead({ eyebrow, title, copy, light = false, className = "" }) {
    return (
        <FadeUp className={className}>
            <div className="flex items-center gap-4">
                <span className="h-px w-10 bg-gold" aria-hidden="true" />
                <span className="text-xs font-semibold uppercase tracking-[0.32em] text-gold">
                    {eyebrow}
                </span>
            </div>
            <h2
                className={`mt-6 font-serif text-3xl font-light leading-[1.12] tracking-tight sm:text-4xl lg:text-5xl ${
                    light ? "text-navy-deep" : "text-ivory"
                }`}
            >
                {title}
            </h2>
            {copy && (
                <p
                    className={`mt-5 max-w-2xl text-base leading-relaxed md:text-lg ${
                        light ? "text-navy-deep/70" : "text-slate-300/80"
                    }`}
                >
                    {copy}
                </p>
            )}
        </FadeUp>
    );
}

export function ChapterTag({ children, light = false }) {
    return (
        <FadeUp>
            <span
                className={`text-[11px] font-semibold uppercase tracking-[0.4em] ${
                    light ? "text-navy-deep/50" : "text-slate-500"
                }`}
            >
                {children}
            </span>
        </FadeUp>
    );
}
